import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Search } from '../../../shared/user.model';
import swal from 'sweetalert2';

@Component({
  selector: 'app-clients-grid',
  templateUrl: './clients-grid.component.html',
  styleUrls: ['./clients-grid.component.css']
})
export class ClientsGridComponent implements OnInit {
  s: any;
  isSearch: boolean = false;;
  title = "View Client";
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  clientList:any=[];
  ul:any={};
  data: any;


  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() {
    this.GetAllClients(this.itemsPerPage, 1)
  }

  pageChanged(pageNumber: number) {
    //if (this.isSearch)
      //this.onSearch(this.s, this.itemsPerPage, pageNumber);
   // else
      this.GetAllClients(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
   // if (this.isSearch)
      //this.onSearch(this.s, this.itemsPerPage, pageNo);
    //else
      this.GetAllClients(this.itemsPerPage, pageNo);
  }


  GetAllClients(itemsPerPage: number, pageNo: number) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllClients(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.clientList = data.clientmodel;
          console.log(this.clientList);
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
  }

  DeleteClient(C_Id){
    debugger;
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.userService.DeleteClient(C_Id);
        this.data.subscribe(
         (response: any) => {
             this.GetAllClients(this.itemsPerPage, 1)          
         },       
      ); 
    } 
    })
    }


    onSearch(s, itemsPerPage: number, pageNo: number) {  
      debugger; 
      this.isSearch = true;
      let searchText = this.s.SearchText;
      let searchCriteria = this.s.SearchCriteria;
      if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
        swal("Warning!", "Please enter the search criteria and search text.", "warning");
      else {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.SearchClient(searchCriteria, searchText,itemsPerPage,pageNo)
          .subscribe(
            (data: any) => {
              if(data.clientmodel.length!=0){              
            this.clientList = data.clientmodel;
            this.totalItems = data.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;
              document.getElementById('loader-spinner').style.display = "none";
            }
            else
            {
            document.getElementById('loader-spinner').style.display = "none";         
            }
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              //swal('Search Failed.');
              //this.errorHandler.HandlerError(error);
            });
      }
    }


  
}



// WEBPACK FOOTER //
// ./src/app/masters/clients/clients-grid/clients-grid.component.ts